<mat-dialog-content>
<div class="insight-container">
  <div class="insight-title-box">
    <div class="insight-title">{{ onlyRationale ? 'Regulatory Rating' : 'AI Rationale' }}</div>
    <div class="insigh-close-icon"><mat-icon mat-dialog-close>close</mat-icon></div>
  </div>
  <div class="insight-content">
    <mat-accordion multi="true" class="rationale-markdown">
        <mat-expansion-panel #panel2 expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ onlyRationale ? 'Summary Conclusion' : 'Rationale' }}
          </mat-panel-title>
          <span class="panel-arrow-icon" style="margin-left:auto;display:flex;align-items:center;">
            <mat-icon>{{panel2.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
          </span>
        </mat-expansion-panel-header>
     <div class="rational mt-2">
       <markdown [data]="insightData.data.ai_rationale"></markdown>
     </div>
      </mat-expansion-panel>
      <mat-expansion-panel *ngIf="!onlyRationale" #panel1 expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Chunks
          </mat-panel-title>
          <span class="panel-arrow-icon" style="margin-left:auto;display:flex;align-items:center;">
            <mat-icon>{{panel1.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
          </span>
        </mat-expansion-panel-header>
            <div class="chunk-item" *ngFor="let item of insightData.data.traces; let i = index; first as isFirst">
              <div class="chunk-title">
                <markdown [data]="(i+1) + '. Chunk ' + (i+1)"></markdown>
              </div>
              <div class="doc-details mt-1">
                <markdown [data]="'**Document Category:** ' + item.doc_label + '  \n**Original Filename:** ' + item.original_filename + '  \n**Page:** ' + item.page_number + '  \n**Doc Id:** ' + item.doc_id"></markdown>
                <!-- <markdown [data]="'**Document Category:** ' + item.doc_label"></markdown>
                <markdown [data]="'**Page:** ' + item.page_number"></markdown>
                <markdown [data]="'**Doc Id:** ' + item.doc_id"></markdown> 
                <markdown [data]="'**Original Filename:** ' + item.original_filename"></markdown> -->
              </div>
              <div class="chunk-content">
                <markdown [data]="item.chunk"></markdown>
              </div>
            </div>
      </mat-expansion-panel>
      <mat-expansion-panel *ngIf="!onlyRationale" #panel3 expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            AI Confidence
          </mat-panel-title>
          <span class="panel-arrow-icon" style="margin-left:auto;display:flex;align-items:center;">
            <mat-icon>{{panel3.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
          </span>
        </mat-expansion-panel-header>
        <div class="confidence-box">
          <!-- <div class="title">Accuracy <mat-icon>info</mat-icon> </div> -->
          <mat-progress-spinner
            class="redSpinner"
              [mode]="'determinate'"
              [value]="(insightData.data.confidence_level_percentage * 100)">
            </mat-progress-spinner>
            <div class="confidence-percentage">{{(insightData.data.confidence_level_percentage * 100)}} %</div>
          </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
</mat-dialog-content>